"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaults = {
    /**
     * What url will be used to test the proxy settings.
     */
    testUrl: "https://www.bing.com/",
};
//# sourceMappingURL=defaults.js.map